import { baseApi } from '../baseApi';

export interface Settings {
  id: string;
  classId: string;
  paymentGateway: string;
  paymentApiKey: string;
  paymentApiSecret: string;
  paymentWebhookSecret?: string | null;
  paymentMode?: string;
  platformCharge: number;
  taxRate: number;
  notesPrice: number;
  videosPrice: number;
  examsPrice: number;
  chapterPrice: number;
  theme: string;
  appName?: string;
  appLogo?: string;
  appTagline?: string | null;
  maxAllowedDevices: number;
  blockSimultaneousLogin: boolean;
  smsOtpEnabled?: boolean;
  smsProvider?: string;
  smsApiKey?: string | null;
  smsSenderId?: string | null;
  smsEntityId?: string | null;
  smsTemplateId?: string | null;
  supportEmail?: string | null;
  supportWhatsApp?: string | null;
  supportPhone?: string | null;
  socialYoutube?: string | null;
  socialInstagram?: string | null;
  socialTelegram?: string | null;
  instituteAddress?: string | null;
  gstin?: string | null;
  termsAndConditions?: string | null;
  paymentPolicy?: string | null;
}

export const settingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<{ success: boolean; data: Settings }, void>({
      query: () => '/api/settings',
      providesTags: ['Settings'],
    }),
    updateSettings: builder.mutation<{ success: boolean; data: Settings }, Partial<Settings>>({
      query: (body) => ({
        url: '/api/settings',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
});

export const { useGetSettingsQuery, useUpdateSettingsMutation } = settingApi;
